import { render, staticRenderFns } from "./addBuildingView.vue?vue&type=template&id=04d7a90c&scoped=true"
import script from "./addBuildingView.vue?vue&type=script&lang=js"
export * from "./addBuildingView.vue?vue&type=script&lang=js"
import style0 from "./addBuildingView.vue?vue&type=style&index=0&id=04d7a90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7a90c",
  null
  
)

export default component.exports